export var BlockQuotation = 'blockquote';